import { useMemo } from "react";

import { Patient } from "../models/patient";
import { PatientData } from "../models/patient-data";
import { useAllPatientData } from "../queries/patients-query";

export const usePatientData: (options: {
  patientId?: Patient["id"];
  exportId?: PatientData["exportId"];
}) => PatientData | undefined = ({ patientId, exportId }) => {
  const { data: exports } = useAllPatientData(patientId);
  return useMemo(() => {
    if (!patientId) return;
    if (exportId) return exports?.find((p) => p.exportId === exportId);
    return exports?.[exports.length - 1];
  }, [exportId, exports, patientId]);
};
